import { isCanceledOrDeleted } from "@stores/purchases/utils";
import { ReactElement } from "react";
import { Box } from "@mantine/core";
import { IPurchaseCardProps } from "../types";
import {
  CloudPurchaseCardFooter,
  CloudPurchaseCardHeader,
} from "./CloudPurchaseCard.components";
import { PurchaseDetailSection } from "../section/PurchaseDetailSection/PurchaseDetailSection";
import { CanceledSubscriptionCard } from "../section/CanceledSubscriptionSection/CanceledSubscriptionSection";
import PurchaseCard from "../PurchaseCard/PurchaseCard";

export default function CloudPurchaseCard({
  purchase,
}: IPurchaseCardProps): ReactElement {
  const isPurchaseCanceledOrDeleted = isCanceledOrDeleted(purchase);

  return (
    <PurchaseCard purchase={purchase}>
      <CloudPurchaseCardHeader purchase={purchase} />

      <Box mt="lg">
        {isPurchaseCanceledOrDeleted ? (
          <CanceledSubscriptionCard purchase={purchase} />
        ) : (
          <PurchaseDetailSection purchase={purchase} />
        )}
      </Box>
      {!isPurchaseCanceledOrDeleted && (
        <CloudPurchaseCardFooter purchase={purchase} />
      )}
    </PurchaseCard>
  );
}
